import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, getCodeName} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';

// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';

import ProfileCompanyPart from './profile-company.part';
import {useParams} from "react-router-dom";
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileCompanyPage = () => {
  const defUrl = '/company'
  const {more} = useParams()

  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value:-1, visible: more && (more === 'more'), canSrch: false, selList:[]},
    {field: 'name', placeholder: '업체명',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'bizNum', placeholder: '사업자등록번호',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'ceo', placeholder: '대표자',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'startDt', placeholder: '개업일',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'addr1', placeholder: '주소',    type:'text', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'addr2', placeholder: '상세주소',    type:'text', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'manager', placeholder: '담당자', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'phone', placeholder: '대표전화', type:'number', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'email', placeholder: '이메일', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'fax', placeholder: '팩스', type:'number', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'remark', placeholder: '비고', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'bSttCd', placeholder: '사업자상태', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'taxTypeCd', placeholder: '과세유형', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'certified', placeholder: '검증여부', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'reqUserId', placeholder: '신청자ID', type:'text', value:-1, visible: false, canSrch: false, selList:[]},
    {field: 'conUserId', placeholder: '승낙자ID', type:'text', value:-1, visible: false, canSrch: false, selList:[]},
    {field: 'statCode', placeholder: '상태코드', type:'text', value:'S001', visible: false, canSrch: false, selList:[]},
    {field: 'statName', placeholder: '상태', type:'text', value:'S001', visible: true, canSrch: false, selList:[]},
    {field: 'reqUserId', placeholder: '상태', type:'text', value:'-1', visible: false, canSrch: false, selList:[]},
    {field: 'conUserId', placeholder: '상태', type:'text', value:'-1', visible: false, canSrch: false, selList:[]},
  ]
  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []  
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)

  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const account = useSelector(state => state.accountReducer)
	const schola = useSelector((state) => state.scholaReducer)

  
  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }


  useEffect(() => {
    onLoad()
  }, [pageInfo])

  
  const onLoad = async() => {
    openIndicator()
    let url = `/company/req/user/${account.user.id}`
    const newTerms = {}
    Object.keys(termsRef.current).forEach(key => {
      if(termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key]
      }
    })
    
    let resp = await WebService.get(url, {schoolId:schola.id, pageNum:pageInfo.pageNum, pageSize:pageInfo.pageSize, terms:JSON.stringify(newTerms)})

    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.forEach(r => {
        r.statName = getCodeName(codes, 'SA16', r.statCode)
      })
      const totalCount = repMessage.totalCount
      set_totalCount(totalCount)
      records.forEach(r => {
        r.isDetail = false
        r.schoolList = []
      })

      set_dataList(records)
    }
    else {
      openSnackbar(resp.repMessage)
    }

    closeIndicator()
  }

  const onDetail = async(id) => {
    const newDataList = [...dataList]
    const found = newDataList.find(d => d.id === id)
    const url = `${defUrl}/school`
    const resp = await WebService.get(url, {companyId: id})
    
    if(resp.repCode === 'ack') {
      const resultMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(resultMessage.records)
      found.schoolList = records
    }
    found.isDetail = !found.isDetail 
    set_dataList(newDataList)
    dgHandler[1](true)
  }

  const onDelete = async(id) => {
    const url = defUrl
    const resp = await WebService.delete(url, {id: id})
    if(resp.repCode === 'ack') {
      onLoad()
      openSnackbar('삭제되었습니다.')
    }
    
  }
  
  const onCreate = () => {
    set_record(defRecord)
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      obj[k] = ''
    })
    set_terms(obj)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage })
  }
  
  const handleChangeRowsPerPage = (event) => {
    
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({pageNum:0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  

  const DgContent = () => {
    const onSubmit = async () => {
      const url = `${defUrl}/school/rltn2`
      const data = {
        company: JSON.stringify(activeRow),
        schoolList: JSON.stringify(activeRow.schoolList)
      }
      const resp = await WebService.post(url, data)
      if(resp.repCode === 'ack') {
        onLoad()
        handleChange()
        openSnackbar('저장되었습니다.')
      }
      else {
        openSnackbar('에러 발생')
      }
    }

    const onChangeSchool = async(schoolId, e) => {
      const school = schoolContainer.find(d => d.id === schoolId)
      const found = activeRow.schoolList.find(d => d.id === schoolId)
      if(found && !e.target.checked) {
        const idx = activeRow.schoolList.indexOf(found)
        activeRow.schoolList.splice(idx, 1)
        handleChange()
      }
      if(!found && e.target.checked) {
        activeRow.schoolList.push(school)
        handleChange()
      }
      
    }

    const validate = () => {}
    const [
      activeRow,
      errors,
      formLoading,
      handleChange,
      handleSubmit, 
     ] = useForm({
      initialValues: {...record}, 
      onSubmit: onSubmit,
      validate: validate,
    });
    const [schoolList, set_schoolList] = useState([])
    const [schoolContainer, set_schoolContainer] = useState([])
    const [emailError, setEmailError] = useState('');
    const [passwordState, setPasswordState] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [nameError, setNameError] = useState('');
    const [registerError, setRegisterError] = useState('');
    // const Boxs = styled(Box)`
    //   padding-bottom: 40px !important;
    // `;
    

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    useEffect(() => {
      const new_schoolContainer = [...activeRow.schoolList]
      set_schoolContainer(new_schoolContainer)
    }, [])
    return (
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography component="h1" variant="h5">
            기본정보
          </Typography>
          <Boxs component="form" noValidate sx={{ mt: 3 }}>
            <FormControl component="fieldset" variant="standard">
              <Grid container spacing={2}>
                {
                  fields.map((col, index) => {
                    if(col.visible) {
                      return(
                        <Grid item xs={3} key={col.field}>
                          <TextField
                            size='small'
                            required
                            fullWidth
                            name={col.field}
                            label={col.placeholder}
                            value={activeRow[col.field]}
                            onChange={handleChange}
                          />
                        </Grid>
                      )
                    }
                  })
                }
              </Grid>
            </FormControl>
          <FormHelperTexts>{registerError}</FormHelperTexts>
        </Boxs>
        <Typography component="h1" variant="h5">
          위탁 대상 학교
        </Typography>
        <Autocomplete
          disablePortal
          options={schoolList}
          onInputChange={async (event, value, reason) => {
            if(reason === 'input') {
              const records = await searchSchool(value)
              set_schoolList(records)
            }
          }}
          onChange = {(e, v)=> {
            if(!schoolContainer.find(s => s.id === v.id)) {
              const new_schoolContainer = [...schoolContainer]
              new_schoolContainer.push(v)
              set_schoolContainer(new_schoolContainer)
            }
          }}
          size='small'
          sx={{ width: 300 }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => <TextField  {...params} label="학교명" />}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>

            {
              // activeRow.schoolList.map((s, index) => {
              //   return(
              //     <FormControlLabel
              //       key = {s.id}
              //       control={
              //         <Checkbox 
              //           color="primary"  
              //           onChange={(e) => { onChangeSchool(s.id, e)}} 
              //           checked = {activeRow.schoolList.find(s2 => s2.id === s.id) ? true: false 
              //         }/>
              //       }
              //       label={s.name}
              //     />
              //   )
              // })
            }
            {

              schoolContainer.map((s, index) => {
                if(activeRow.schoolList) {
                  return(
                    <FormControlLabel
                      key = {s.id}
                      control={
                        <Checkbox 
                          color="primary"  
                          onChange={(e) => { onChangeSchool(s.id, e)}} 
                          checked = {activeRow.schoolList.find(s2 => s2.id === s.id) ? true: false 
                        }/>
                      }
                      label={s.name}
                    />
                  )
                }
              })
            }
          </Grid>
        </Grid>
        <Button variant='contained' color='primary' size='small' onClick={onSubmit} sx={{mt: 10, width:100}}>저장</Button>
      </Box>
    </Container>
    );
  }
    

  const dg_title = '회사 등록 신청'
  const memo_DgContent = useMemo(()=> {return <ProfileCompanyPart company={record} />}, [record])
  if(dataList != null) {
    return (
      <div >
        <MyDialog title={dg_title} component={memo_DgContent} dialogHandler={dgHandler} callback={onLoad}/>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>등록 회사 목록</h1>
          </div>
        </div>
        <div style={{display:'flex', flexDirection:'row'}}>
          <Button variant='outlined' color='primary' size='small' onClick={() => {onCreate()}}>회사 등록 신청</Button>
        </div>
        
        <div style={{paddingTop:20}}>
          <MUITable>
            <MyTableHead >
              <TableRow>
                {
                  fields.map((col, index) => {
                    if(col.visible) {
                      return(
                        <TableCell key={index} size='small'>
                          {col.placeholder}
                          {col.canSrch? 
                            ( 
                              <Fragment>
                                  <TextField label="" variant="outlined" size='small' inputProps={{style: {fontSize: '0.875em', padding:5, backgroundColor:'#fff'}}} 
                                    value={terms[col.field]}
                                    onChange={(e) => {
                                      const newTerms = {...terms}
                                      newTerms[col.field] = e.target.value
                                      set_terms(newTerms)
                                    }}
                                  />
                              </Fragment>
                            )
                            : (
                              <Fragment>
                              </Fragment>
                            )
                          }
                        </TableCell>
                      )
                    }
                  })
                }
                <TableCell size='small'>
                 
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                dataList.map((row, index) => {
                  return(
                    <Fragment key={index}>
                      <TableRow onClick={()=> {
                        set_selIdx(index)
                        set_record(row)
                      }}>
                          {
                            fields.map((col, index2) => {
                              if(col.visible) {
                                return(
                                  <TableCell key={index2} size='small'>
                                    {row[col.field]}
                                  </TableCell>
                                )
                              }
                            })
                          }
                          <TableCell size='small'>
                            {/*
                            <FlatButton variant='outlined' size='small'  style={{marginRight:5}} onClick={() => onDetail(row.id)}>보기</FlatButton>
                            <FlatButton variant='outlined'  color='error' size='small' onClick={() => onDelete(row.id)}>삭제</FlatButton>
                            */}
                            
                          </TableCell>
                        </TableRow>
                      </Fragment>
                  )
                })
              }
            </TableBody>
            <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 20, { label: 'All', value: -1 }]}
                colSpan={visibleColumns.length + 1}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={
                  ({ from, to, count }) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }
                }
                labelRowsPerPage={'페이지당 갯수'}
              />
            </TableRow>
          </TableFooter>
          </MUITable>

           {renderSnackbar()}
           {renderIndicator()}
            <dg_content />
          </div>

      </div>
      
    );
  }
  
}

export default ProfileCompanyPage
